var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 4.35156C3.6121 4.35385 3.18989 4.3721 2.84295 4.51772C2.357 4.72169 1.96125 5.09846 1.73007 5.57724C1.54136 5.96805 1.51048 6.46875 1.44872 7.47013L1.35195 9.03932C1.19837 11.5296 1.12157 12.7747 1.8523 13.563C2.58303 14.3513 3.81407 14.3513 6.27618 14.3513H8.72381C11.1859 14.3513 12.417 14.3513 13.1477 13.563C13.8784 12.7747 13.8016 11.5296 13.6481 9.03932L13.5512 7.47013C13.4895 6.46875 13.4586 5.96805 13.2699 5.57724C13.0387 5.09846 12.643 4.72169 12.1571 4.51772C11.8101 4.3721 11.3879 4.35385 10.625 4.35156",
    stroke: "#141B34",
    strokeWidth: 1.12982,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 4.97656L10.0714 3.59246C9.8325 2.99529 9.62463 2.31788 9.01038 2.01378C8.68275 1.85156 8.2885 1.85156 7.5 1.85156C6.7115 1.85156 6.31725 1.85156 5.98959 2.01378C5.37538 2.31788 5.16751 2.99529 4.92864 3.59246L4.375 4.97656",
    stroke: "#141B34",
    strokeWidth: 1.12982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 9.35156C9.6875 10.5597 8.70812 11.5391 7.5 11.5391C6.29188 11.5391 5.3125 10.5597 5.3125 9.35156C5.3125 8.14344 6.29188 7.16406 7.5 7.16406C8.70812 7.16406 9.6875 8.14344 9.6875 9.35156Z",
    stroke: "#141B34",
    strokeWidth: 1.12982
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.35156H7.5064",
    stroke: "#141B34",
    strokeWidth: 1.50643,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.796db1a0a11d673297843a5551d9693f.svg";
export { ForwardRef as ReactComponent };